var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section is-size-7"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Email Tracking\n          "), _c('button', {
    staticClass: "btn btn-light btn-pill card-header-actions",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.getEmailCases()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Case List"
    },
    on: {
      "click": function($event) {
        _vm.switchTab('Case List')
      }
    }
  }, [(_vm.activeComponent == 'Case List') ? _c('div', [(_vm.showReAllocationForm && _vm.userRole.toLowerCase() !== 'associate') ? _c('div', [_c('form', {
    attrs: {
      "name": "tlreallocation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reallocateCase()
      }
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v(" Re-Allocate Email ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_vm._v("\n                              Agent\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reallocate.agent),
      expression: "reallocate.agent"
    }],
    staticClass: "is-hovered form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reallocate.agent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Agent--")]), _vm._v(" "), _vm._l((_vm.activeAgents), function(agent, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": agent
      }
    }, [_vm._v(_vm._s(agent))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "submit",
      "name": "Reallocate",
      "title": "Reallocate Ticket"
    }
  }, [_vm._v("Re-Allocate")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.applyFilter()
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "date_data"
    }
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "Date",
      "value": "Created_Date",
      "Checked": ""
    },
    on: {
      "click": function($event) {
        _vm.onCheckCreatedDate($event)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Search by Created Date")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "Date",
      "value": "Modfied_Date"
    },
    on: {
      "click": function($event) {
        _vm.onCheckModifiedDate($event)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Search by Modified Date")]), _c('br')]), _vm._v(" "), (_vm.AI_ENABLED == true) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.aiassisted),
      expression: "filter.aiassisted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "aiassisted"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.aiassisted) ? _vm._i(_vm.filter.aiassisted, null) > -1 : (_vm.filter.aiassisted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.filter.aiassisted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.filter.aiassisted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.filter.aiassisted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter.aiassisted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Show AI drafts")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" From Date : ")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "required": !_vm.filter.caseid && !_vm.filter.fromemail && !_vm.filter.fcaccountid,
      "not-after": _vm.filter.toDate
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.filter.fromDate),
      callback: function($$v) {
        _vm.filter.fromDate = $$v
      },
      expression: "filter.fromDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" To Date : ")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lang": "en",
      "required": !_vm.filter.caseid && !_vm.filter.fromemail && !_vm.filter.fcaccountid,
      "type": "date",
      "not-before": _vm.filter.fromDate,
      "not-after": _vm.maxToDate
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.filter.toDate),
      callback: function($$v) {
        _vm.filter.toDate = $$v
      },
      expression: "filter.toDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), (_vm.userRole.toLowerCase() !== 'associate') ? _c('option', {
    attrs: {
      "value": "allocationpending"
    }
  }, [_vm._v("AllocationPending")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "allocated"
    }
  }, [_vm._v("Allocated")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inprocess"
    }
  }, [_vm._v("InProcess")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "followup"
    }
  }, [_vm._v("Follow up")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "close"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "spam"
    }
  }, [_vm._v("Spam")]), _vm._v(" "), (_vm.userRole.toLowerCase() !== 'associate') ? _c('option', {
    attrs: {
      "value": "trash"
    }
  }, [_vm._v("Trash")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" Agent : ")]), _vm._v(" "), (_vm.userRole.toLowerCase() !== 'associate') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.agent),
      expression: "filter.agent"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.agent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.activeAgents), function(agent, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": agent
      }
    }, [_vm._v(_vm._s(agent))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.userRole.toLowerCase() === 'associate') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.agent),
      expression: "filter.agent"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.agent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.filter.agent
    }
  }, [_vm._v(_vm._s(_vm.filter.agent))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" Email Case ID : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.caseid),
      expression: "filter.caseid",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Case ID"
    },
    domProps: {
      "value": (_vm.filter.caseid)
    },
    on: {
      "keypress": function($event) {
        _vm.checkIsNumber()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.caseid = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" Email From : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.fromemail),
      expression: "filter.fromemail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": " Enter Email From"
    },
    domProps: {
      "value": (_vm.filter.fromemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.fromemail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" Email To : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.toemail),
      expression: "filter.toemail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": " Enter Email To"
    },
    domProps: {
      "value": (_vm.filter.toemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.toemail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v(" Email CC : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.ccemail),
      expression: "filter.ccemail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": " Enter Email CC"
    },
    domProps: {
      "value": (_vm.filter.ccemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.ccemail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Email Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.filter.subject),
      expression: "filter.subject",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": " Enter Email Subject"
    },
    domProps: {
      "value": (_vm.filter.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter.subject = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "name": "searchButton",
      "size": "sm"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetFilter()
      }
    }
  }, [_vm._v(" Reset ")]), _vm._v(" "), (_vm.userRole === _vm.constantVariable.TEAM_LEADER) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "variant": "primary",
      "name": "searchButton",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.exportEmailerAIReport()
      }
    }
  }, [_vm._v("Export")]) : _vm._e(), _vm._v("        \n                                    ")])])])])])])])])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loadCount
    },
    on: {
      "update:active": function($event) {
        _vm.loadCount = $event
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("Total Count: "), _c('strong', [_vm._v(_vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', [(_vm.emailCasesArray.length) ? _c('div', {
    staticClass: "rowFullTable"
  }, [_c('table', {
    staticClass: "table table-fixed table-hover tableFixHeadBottom table-text-cente"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticClass: "row-ID"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.checkAllSelected,
      "name": "Select All"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "click": _vm.selectAllCase,
      "__c": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("CaseID")]), _vm._v(" "), _c('th', {
    staticClass: "row-Desc",
    staticStyle: {
      "column-width": "300px"
    }
  }, [_vm._v("AssignTo")]), _vm._v(" "), (_vm.AI_ENABLED == true) ? _c('th', {
    staticClass: "row-ID",
    staticStyle: {
      "column-width": "100px"
    }
  }, [_vm._v("Category")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "row-incident-level"
  }, [_vm._v("EmailInfo")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Attachment")]), _vm._v(" "), _c('th', {
    staticClass: "row-ID",
    staticStyle: {
      "column-width": "100px"
    }
  }, [_vm._v("Preview")]), _vm._v(" "), (_vm.AI_ENABLED == true) ? _c('th', {
    staticClass: "row-ID",
    staticStyle: {
      "column-width": "100px"
    }
  }, [_vm._v("AI")]) : _vm._e(), _vm._v(" "), (_vm.userRole.toLowerCase() === 'associate' && _vm.filter.status.toLowerCase() !== 'spam') ? _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Action")]) : (_vm.userRole.toLowerCase() === 'team leader' &&
    _vm.filter.status.toLowerCase() !== 'allocationpending' &&
    _vm.filter.status.toLowerCase() !== 'allocated' &&
    _vm.filter.status.toLowerCase() !== 'inprocess' &&
    _vm.filter.status.toLowerCase() !== 'trash' &&
    _vm.filter.status.toLowerCase() !== 'spam') ? _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Action")]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "position-relative"
  }, [_vm._l((_vm.emailCasesArray), function(emailCase, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCaseIds),
        expression: "selectedCaseIds"
      }],
      attrs: {
        "id": emailCase.caseid,
        "type": "checkbox",
        "name": "Select All"
      },
      domProps: {
        "value": emailCase.caseid,
        "checked": Array.isArray(_vm.selectedCaseIds) ? _vm._i(_vm.selectedCaseIds, emailCase.caseid) > -1 : (_vm.selectedCaseIds)
      },
      on: {
        "click": function($event) {
          _vm.selectCase(emailCase, $event)
        },
        "__c": function($event) {
          var $$a = _vm.selectedCaseIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = emailCase.caseid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCaseIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedCaseIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCaseIds = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link px-0",
      attrs: {
        "type": "button",
        "title": "View Email Case Log"
      },
      on: {
        "click": function($event) {
          _vm.selectedTab = 1;
          _vm.showModelPOPs(emailCase.caseid)
        }
      }
    }, [_vm._v(_vm._s(emailCase.caseid))]), _vm._v(" "), _c('br'), (emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes') ? _c('span', {
      class: {
        'tag is-warning': emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'
      }
    }, [_vm._v("RepeatEmail")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "media-body"
    }, [_c('b', [_vm._v("Assigned To : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.assignedto))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Created Date :")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formaEmailtDate(emailCase.emaildate)))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last Modified By : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.lastmodifiedby))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last Modified Date : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(emailCase.lastmodifieddate)))])])]), _vm._v(" "), (_vm.AI_ENABLED == true) ? _c('td', [_c('div', {
      staticClass: "media-body"
    }, [_c('b', [_vm._v(_vm._s(emailCase.maintypename))])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('b', [_vm._v("From:")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                " + _vm._s(emailCase.fromid) + "\n                              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Subject:")]), _vm._v(" "), _c('span', [(emailCase.subject && emailCase.subject && emailCase.subject.length <= 200) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.subject))]) : (emailCase.subject && emailCase.subject) ? _c('span', {
      staticClass: "text-muted"
    }, [_c('b-tooltip', {
      attrs: {
        "label": emailCase.subject,
        "multilined": ""
      }
    }, [_vm._v("\n                                    " + _vm._s(emailCase.subject.substring(0, 200)) + " ...\n                                  ")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Originate Source:")]), _vm._v(" "), (emailCase.originatesource) ? _c('span', [(emailCase.originatesource.toLowerCase() === 'cbfeedbackemail') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                  CB\n                                ")]) : (emailCase.originatesource.toLowerCase() === 'feedbackemail') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                  Web\n                                ")]) : (emailCase.originatesource.toLowerCase() === 'needhelp') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                  Need Help\n                                ")]) : _vm._e()]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" CCEmail")])]), _vm._v(" "), _c('td', [_c('h6', [(emailCase.status == 'allocationpending') ? _c('span', {
      class: [emailCase.status == 'allocationpending' ? 'badge badge-warning is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'allocated') ? _c('span', {
      class: [emailCase.status == 'allocated' ? 'badge badge-danger is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'inprocess') ? _c('span', {
      class: [emailCase.status == 'inprocess' ? 'badge badge-info is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'Close') ? _c('span', {
      class: [emailCase.status == 'Close' ? 'badge badge-success is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'spam') ? _c('span', {
      class: [emailCase.status == 'spam' ? 'badge badge-secondary is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'trash') ? _c('span', {
      class: [emailCase.status == 'trash' ? 'badge badge-dark is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'followup') ? _c('span', {
      class: [emailCase.status == 'followup' ? 'badge badge-info is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.priority == 0) ? _c('span', {
      staticStyle: {
        "background-color": "#e32d5e",
        "line-height": "2.8",
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("CEOEscalation")])]) : _vm._e()])]), _vm._v(" "), _c('td', [(emailCase && emailCase.isattachment && emailCase.isattachment.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
      attrs: {
        "to": {
          path: encodeURI('/emailattachment'),
          query: {
            inboxID: emailCase.inboxid,
            caseID: emailCase.caseid
          }
        },
        "id": "link",
        "title": "View Attachment",
        "target": "_blank"
      }
    }, [_c('a', [_c('button', {
      attrs: {
        "variant": "outline-primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    })])])])], 1) : _c('span', [_vm._v("\n                                No\n                              ")])]), _vm._v(" "), _c('td', [(_vm.userRole.toLowerCase() === 'associate') ? _c('p', [(emailCase.status.toLowerCase() === 'inprocess' || emailCase.status.toLowerCase() === 'allocated' || emailCase.status.toLowerCase() === 'close' || emailCase.status.toLowerCase() === 'followup') ? _c('EmailPreview', {
      attrs: {
        "setCaseID": [emailCase.caseid],
        "buttonType": 'eye'
      }
    }) : _c('b-button', {
      attrs: {
        "variant": "outline-primary btn-sm",
        "title": "Email Preview"
      },
      on: {
        "click": function($event) {
          _vm.notAllowedPreview(emailCase.caseid, emailCase.status)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])], 1) : _c('p', [_c('EmailPreview', {
      attrs: {
        "setCaseID": [emailCase.caseid],
        "buttonType": 'eye'
      }
    })], 1)]), _vm._v(" "), (_vm.AI_ENABLED == true) ? _c('td', [(_vm.AI_ENABLED == true && emailCase.aiassisted == 'Y') ? _c('b-button', {
      attrs: {
        "variant": "outline-primary btn-sm"
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.userRole.toLowerCase() === 'associate' && _vm.filter.status.toLowerCase() !== 'spam') || (_vm.userRole.toLowerCase() === 'team leader' &&
      _vm.filter.status.toLowerCase() !== 'allocationpending' &&
      _vm.filter.status.toLowerCase() !== 'allocated' &&
      _vm.filter.status.toLowerCase() !== 'inprocess' &&
      _vm.filter.status.toLowerCase() !== 'trash' &&
      _vm.filter.status.toLowerCase() !== 'spam')) ? _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [(_vm.filter.status.toLowerCase() !== 'spam' && emailCase.status.toLowerCase() === 'allocated' || emailCase.status.toLowerCase() === 'inprocess') ? _c('div', [_c('b-dropdown', {
      attrs: {
        "text": "Settings",
        "variant": "p-0",
        "right": ""
      }
    }, [_c('template', {
      slot: "button-content"
    }, [_c('i', {
      staticClass: "fa fa-cogs"
    })]), _vm._v(" "), (emailCase.status.toLowerCase() === 'inprocess') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.actionType('raiseticket', emailCase)
        }
      }
    }, [_vm._v("Raise Ticket")]) : _vm._e(), _vm._v(" "), (emailCase.status.toLowerCase() === 'allocated') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.actionType('assigntome', emailCase)
        }
      }
    }, [_vm._v("Assign To Me")]) : _vm._e(), _vm._v(" "), (emailCase.status.toLowerCase() !== 'spam') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.actionType('markasspam', emailCase)
        }
      }
    }, [_vm._v("Mark As Spam")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.actionType('autoreply', emailCase)
        }
      }
    }, [_vm._v("Auto Reply")])], 2)], 1) : _c('div', [_c('b-dropdown', {
      attrs: {
        "text": "Settings",
        "variant": "p-0",
        "right": ""
      }
    }, [_c('template', {
      slot: "button-content"
    }, [_c('i', {
      staticClass: "fa fa-cogs"
    })]), _vm._v(" "), _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.getDetailLevel(emailCase, index)
        }
      }
    }, [_vm._v("View Tickets")]), _vm._v(" "), (emailCase.status.toLowerCase() === 'followup' && _vm.userRole.toLowerCase() === 'associate') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.actionType('autoreply', emailCase)
        }
      }
    }, [_vm._v("Auto Reply")]) : _vm._e(), _vm._v(" "), (emailCase.status.toLowerCase() === 'followup' && _vm.userRole.toLowerCase() === 'associate') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.getDetailTicketStatusClose(emailCase, index)
        }
      }
    }, [_vm._v("Auto Close")]) : _vm._e()], 2)], 1)]) : _vm._e()])
  }), _vm._v(" "), (_vm.emailCasesArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Records not found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', [(_vm.totalPages > 1) ? _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.totalPages,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)]) : _vm._e()])])], 1) : _vm._e()])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.isSearchModal_1),
      callback: function($$v) {
        _vm.isSearchModal_1 = $$v
      },
      expression: "isSearchModal_1"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchModal_1),
      expression: "isSearchModal_1"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [(_vm.emailCaseLog.length) ? _c('div', {
    staticClass: "rowFullTable"
  }, [_c('table', {
    staticClass: "table table-fixed table-hover tableFixHeadBottom table-text-cente"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('th', {
    staticClass: "row-Desc"
  }, [_vm._v("Allocation Type")]), _vm._v(" "), _c('th', {
    staticClass: "row-incident-level"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Email Status")]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isSearchModal_1 = _vm.close
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "position-relative"
  }, [_vm._l((_vm.emailCaseLog), function(emailCase, index) {
    return _c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(emailCase.caseid))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.allocationtype || '-'))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.createdby))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("dateFilter")(emailCase.createddate)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.status))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.comment))])])])
  }), _vm._v(" "), (_vm.emailCaseLog.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Records not found")])]) : _vm._e()], 2)])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true
    },
    on: {
      "show": _vm.resetModal,
      "hidden": _vm.resetModal
    },
    model: {
      value: (_vm.isTicketModal),
      callback: function($$v) {
        _vm.isTicketModal = $$v
      },
      expression: "isTicketModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "30px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetraiseticketform()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [(_vm.shipmentResult === false && _vm.shipments.length == 0 && _vm.ticketResultMsg == '') ? _c('div', [_c('form', {
    ref: "form",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Enter Shipping Ids",
      "label-for": "name-input",
      "invalid-feedback": "Shipping Ids is required",
      "state": _vm.shippingIdState
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingIds),
      expression: "shippingIds"
    }],
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "name": "shippingIds",
      "id": "shippingIds",
      "required": "",
      "rows": "5",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.shippingIds)
    },
    on: {
      "change": _vm.formatShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingIds = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "name": "searchButton",
      "size": "sm"
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.resetShipment()
      }
    }
  }, [_vm._v(" Reset ")])])])])]) : (_vm.shipmentResult === true && _vm.shipments.length > 0 && _vm.ticketResultMsg == '') ? _c('div', [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-1",
      modifiers: {
        "accordion-1": true
      }
    }],
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Result")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "accordion-1",
      "visible": "",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [(_vm.validShippingIds.length > 0) ? _c('span', [_c('b', [_vm._v("Valid Shipping Ids")]), _vm._v(" : "), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.validShippingIds.join(', ')) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.invalidShippingIds.length > 0) ? _c('span', [_c('b', [_vm._v("Invalid Shipping Ids")]), _vm._v(": "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.invalidShippingIds.join(', ')))])], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Raise Ticket")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "accordion-2",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Business Flow : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.businessFlow),
      expression: "businessFlow"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.businessFlow = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getBusinessFlow]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Forward"
    }
  }, [_vm._v("Forward")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reverse"
    }
  }, [_vm._v("Reverse")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Search Tagging :  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tag"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Address : ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    attrs: {
      "name": "address",
      "placeholder": ""
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("PinCode :")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    attrs: {
      "name": "pincode",
      "placeholder": ""
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1)]), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reattempt Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :")])])]) : _vm._e(), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [(((_vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM)) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && _vm.ticketTaggingDisplay == false && _vm.alternateContactNo != null && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Alternate No :")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [(((_vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM)) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && _vm.ticketTaggingDisplay == false && _vm.alternateContactNo != null && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    attrs: {
      "name": "alternateContactNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.alternateContactNo),
      callback: function($$v) {
        _vm.alternateContactNo = $$v
      },
      expression: "alternateContactNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('alternateContactNo')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1)])]), _vm._v(" "), (_vm.selectedSubReasonObj.ishubescalation === true) ? [(_vm.selectedSubReasonObj.tat || _vm.selectedSubReasonObj.priority) ? _c('div', {
    staticClass: "row form-group"
  }, [(_vm.selectedSubReasonObj.tat) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("TAT : ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.tat) ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('b-form-input', {
    attrs: {
      "readonly": "",
      "placeholder": "TAT"
    },
    model: {
      value: (_vm.selectedSubReasonObj.tat),
      callback: function($$v) {
        _vm.selectedSubReasonObj.tat = $$v
      },
      expression: "selectedSubReasonObj.tat"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.priority) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Priority : ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.priority) ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('b-form-input', {
    attrs: {
      "readonly": "",
      "placeholder": "Priority"
    },
    model: {
      value: (_vm.selectedSubReasonObj.priority),
      callback: function($$v) {
        _vm.selectedSubReasonObj.priority = $$v
      },
      expression: "selectedSubReasonObj.priority"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Assigned to TL "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.assignedToTLOptions,
      "placeholder": "Select Assigned to TL",
      "selected-option": _vm.selectedAssignedToTLObj
    },
    on: {
      "select": _vm.selectedAssignedToTLOption
    },
    model: {
      value: (_vm.assignedToTLId),
      callback: function($$v) {
        _vm.assignedToTLId = $$v
      },
      expression: "assignedToTLId"
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("SR ID  "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.SRIDs,
      "placeholder": "Select SR ID",
      "selected-option": _vm.selectedSRIDnObj
    },
    on: {
      "select": _vm.selectedSRID
    },
    model: {
      value: (_vm.SRIDsId),
      callback: function($$v) {
        _vm.SRIDsId = $$v
      },
      expression: "SRIDsId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("SR Name "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.SRNames,
      "placeholder": "Select SR Name",
      "selected-option": _vm.selectedSRNamenObj
    },
    on: {
      "select": _vm.selectedSRName
    },
    model: {
      value: (_vm.SRNameId),
      callback: function($$v) {
        _vm.SRNameId = $$v
      },
      expression: "SRNameId"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card c-email-app"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', [_c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("Preview:")]), _vm._v(" "), _c('div', [(_vm.userRole.toLowerCase() === 'associate') ? _c('p', [_c('EmailPreviewRaiseTicket', {
    attrs: {
      "setCaseID": [_vm.caseObj.caseid],
      "buttonType": 'eye'
    }
  }, [_vm._v("Preview ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("From:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(this.emailFrom))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("To:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caseObj.fromid),
      expression: "caseObj.fromid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "to_email",
      "id": "to_email",
      "placeholder": "Type email"
    },
    domProps: {
      "value": (_vm.caseObj.fromid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caseObj.fromid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('to_email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "cc"
    }
  }, [_vm._v("CC:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyTocc1),
      expression: "replyTocc1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "replyTocc1",
      "id": "replyTocc1",
      "placeholder": "Default - abcd@xpressbees.com",
      "rows": "2",
      "cols": "125"
    },
    domProps: {
      "value": (_vm.replyTocc1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyTocc1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("To Add multiple Email ID give comma(,)")])])]), _vm._v(" "), (_vm.invalidEmailFlag) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("\n                                    Invalid Email Ids"), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.invalidEmail) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-2 col-sm-2 col-form-label",
    attrs: {
      "for": "cc"
    }
  }, [_vm._v("Attachment:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    attrs: {
      "id": "image-file",
      "type": "file",
      "multiple": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-1 col-sm-2 col-form-label",
    attrs: {
      "data-v-685aa076": "",
      "for": "message"
    }
  }, [_vm._v("Message:")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto col-sm-11"
  }, [_c('div', {
    staticClass: "form-group mt-4"
  }, [_c('wysiwyg', {
    attrs: {
      "id": "message",
      "name": "message"
    },
    model: {
      value: (_vm.reply),
      callback: function($$v) {
        _vm.reply = $$v
      },
      expression: "reply"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetAddTicket($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])], 2)], 1)], 1)], 1)]) : (_vm.shipmentResult == true && _vm.shipments.length === 0 && _vm.invalidShippingIds.length > 0 && _vm.validShippingIds.length == 0) ? _c('div', [_c('span', [_vm._v("Invalid Shipping Ids: " + _vm._s(_vm.invalidShippingIds.join(', ')))])]) : (_vm.ticketResultMsg == '' && _vm.shipmentResult === true && _vm.shipments.length === 0 && _vm.invalidShippingIds.length === 0) ? _c('div', [_c('span', [_vm._v("Invalid Shipping Ids: " + _vm._s(_vm.invalidShippingIds.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.ticketResultMsg != '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.ticket.length > 0) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    on: {
      "click": function($event) {
        _vm.listExisitngTicketModal = true;
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Update\n              Ticket ")]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true
    },
    on: {
      "show": _vm.resetModal,
      "hidden": _vm.resetModal
    },
    model: {
      value: (_vm.isTicketModal1),
      callback: function($$v) {
        _vm.isTicketModal1 = $$v
      },
      expression: "isTicketModal1"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetraiseticketform()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg1)
    }
  }, [_vm._v(" " + _vm._s(_vm.ticketResultMsg1) + " ")])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.showDetails),
      callback: function($$v) {
        _vm.showDetails = $$v
      },
      expression: "showDetails"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Tickets")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetUpdateTicketModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('table', {
    staticClass: "table table-fixed table-hover table-bordered tableFixHeadBottom table-text-cente"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllRecord),
      expression: "selectAllRecord"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllRecord) ? _vm._i(_vm.selectAllRecord, null) > -1 : (_vm.selectAllRecord)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAllRecord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllRecord = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllRecord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllRecord = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Ticket Id")]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Source")]), _vm._v(" "), _c('th', {
    staticClass: "row-Desc"
  }, [_vm._v("Ticket Type")]), _vm._v(" "), _c('th', {
    staticClass: "row-incident-level"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Sub Reason")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Resolution")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Created By")]), _vm._v(" "), (_vm.userRole.toLowerCase() === 'associate') ? _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Action")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Ticket Log")])]), _vm._v(" "), (_vm.emailCasesArray[_vm.currentCaseId] && _vm.emailCasesArray[_vm.currentCaseId].allTickets) ? _c('tbody', {
    staticClass: "position-relative"
  }, _vm._l((_vm.emailCasesArray[_vm.currentCaseId].allTickets), function(ticket, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ticketIDS),
        expression: "ticketIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "id": ticket.ticketid,
        "type": "checkbox"
      },
      domProps: {
        "value": ticket.ticketid,
        "checked": Array.isArray(_vm.ticketIDS) ? _vm._i(_vm.ticketIDS, ticket.ticketid) > -1 : (_vm.ticketIDS)
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(ticket, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.ticketIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = ticket.ticketid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ticketIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ticketIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ticketIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.typename))]), _vm._v(" "), (_vm.userRole.toLowerCase() === 'associate') ? _c('td', [_vm._v(_vm._s(ticket.action))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.createdby))]), _vm._v(" "), _c('td', [(ticket.ticketstatus != 'Closed') ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "disabled": _vm.disablebtn
      },
      on: {
        "click": function($event) {
          _vm.delayButtonClick(ticket)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    }), _vm._v(" Update")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Closed' && ticket.clientid != null) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "disabled": _vm.disablebtn
      },
      on: {
        "click": function($event) {
          _vm.delayButtonClick(ticket)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-folder-open",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("Reopen")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getemailerTicketHistory(ticket)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View")])])])
  })) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.TicketLogModal1),
      callback: function($$v) {
        _vm.TicketLogModal1 = $$v
      },
      expression: "TicketLogModal1"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TicketLogModal1),
      expression: "TicketLogModal1"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h6', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Ticket log")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head"
  }, [_vm._v("Ticket Id : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ticketIDLog))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.TicketLogModal1 = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Last updated on")]), _vm._v(" "), _c('th', [_vm._v("Resolution")]), _vm._v(" "), _c('th', [_vm._v("Ticket Status")]), _vm._v(" "), _c('th', [_vm._v("Comments")])]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, _vm._l((_vm.resultTicket), function(ticket, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.comments))])])
  }))])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.listExisitngTicketModal),
      callback: function($$v) {
        _vm.listExisitngTicketModal = $$v
      },
      expression: "listExisitngTicketModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Update Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetUpdateTicketModal(), _vm.listExisitngTicketModal = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.openUpdateTicketModal();
      }
    }
  }, [_vm._v("Update Ticket")]), _vm._v(" "), (_vm.updateExistingBulkTicket == false) ? _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Back")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "col-md-12 col-lg-12",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllRecord),
      expression: "selectAllRecord"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllRecord) ? _vm._i(_vm.selectAllRecord, null) > -1 : (_vm.selectAllRecord)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAllRecord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllRecord = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllRecord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllRecord = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sub reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ticket), function(data, index) {
    return (_vm.ticket.length > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ticketIDS),
        expression: "ticketIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "id": data.ticketid,
        "type": "checkbox"
      },
      domProps: {
        "value": data.ticketid,
        "checked": Array.isArray(_vm.ticketIDS) ? _vm._i(_vm.ticketIDS, data.ticketid) > -1 : (_vm.ticketIDS)
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(data, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.ticketIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.ticketid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ticketIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ticketIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ticketIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.ticket.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBulkTicketDiv),
      expression: "showBulkTicketDiv"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "id": "bulkEditTicketDiv"
    }
  }, [_c('b-card-body', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1)]), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reattempt Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :")])])]) : _vm._e(), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkEditShipment($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetAddTicket($event)
      }
    }
  }, [_vm._v("Reset")])])])])])], 1)])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.autoReplyModal),
      callback: function($$v) {
        _vm.autoReplyModal = $$v
      },
      expression: "autoReplyModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Auto Reply")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "30px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.autoReply()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('form', {
    ref: "form",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.sendAutoReply($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("To:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caseObj.fromid),
      expression: "caseObj.fromid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "to_email",
      "id": "to_email",
      "placeholder": "Type email"
    },
    domProps: {
      "value": (_vm.caseObj.fromid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caseObj.fromid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('to_email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "cc"
    }
  }, [_vm._v("CC:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyTocc1),
      expression: "replyTocc1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "replyTocc1",
      "id": "replyTocc1",
      "placeholder": "Default - abcd@xpressbees.com",
      "rows": "2",
      "cols": "125"
    },
    domProps: {
      "value": (_vm.replyTocc1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyTocc1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("To Add multiple Email ID give comma(,)")])])]), _vm._v(" "), (_vm.invalidEmailFlag) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("\n                Invalid Email Ids"), _c('br'), _vm._v("\n                " + _vm._s(_vm.invalidEmail) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyType),
      expression: "replyType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.replyType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getEmailTemplate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Auto Reply",
      "selected": ""
    }
  }, [_vm._v("Auto Reply")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO Auto Reply"
    }
  }, [_vm._v("RTO - Auto Reply")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DTO Auto Reply"
    }
  }, [_vm._v("DTO - Auto Reply")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Business Auto Reply"
    }
  }, [_vm._v("Business - Auto-reply")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Franchisee Auto Reply"
    }
  }, [_vm._v("Franchisee - Auto-reply")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("Subject:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caseObj.subject),
      expression: "caseObj.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "subject",
      "name": "subject_email",
      "id": "subject_email",
      "placeholder": "Type subject",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.caseObj.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caseObj.subject = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-2 col-sm-2 col-form-label",
    attrs: {
      "for": "cc"
    }
  }, [_vm._v("Attachment:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    attrs: {
      "id": "imagefile1",
      "type": "file",
      "multiple": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('wysiwyg', {
    attrs: {
      "id": "editor"
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('data')),
      expression: "errors.has('data')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('data')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('h5', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Close Cases")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closecasemodalChkFlag),
      expression: "closecasemodalChkFlag"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.closecasemodalChkFlag) ? _vm._i(_vm.closecasemodalChkFlag, null) > -1 : (_vm.closecasemodalChkFlag)
    },
    on: {
      "click": function($event) {
        _vm.onCheckclosecasemodal($event)
      },
      "__c": function($event) {
        var $$a = _vm.closecasemodalChkFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.closecasemodalChkFlag = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.closecasemodalChkFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.closecasemodalChkFlag = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "name": "searchButton",
      "size": "sm"
    }
  }, [_vm._v("Submit")])])], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true
    },
    on: {
      "show": _vm.resetModal,
      "hidden": _vm.resetModal
    },
    model: {
      value: (_vm.editEmailerTicketModal),
      callback: function($$v) {
        _vm.editEmailerTicketModal = $$v
      },
      expression: "editEmailerTicketModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModalLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('b-card', [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Update Raise Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "30px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetraiseticketform()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('div', [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("Update Raised Ticket")])], 1), _vm._v(" "), _c('b-card-body', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Address : ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    attrs: {
      "name": "address",
      "placeholder": ""
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("PinCode :")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    attrs: {
      "name": "pincode",
      "placeholder": ""
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1)]), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Reattempt Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :")])])]) : _vm._e(), _vm._v(" "), ((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR || _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1)])]), _vm._v(" "), (_vm.shouldShowLabel) ? _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("SR ID  "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.SRIDs,
      "placeholder": "Select SR ID",
      "selected-option": _vm.selectedSRIDnObj
    },
    on: {
      "select": _vm.selectedSRID
    },
    model: {
      value: (_vm.SRIDsId),
      callback: function($$v) {
        _vm.SRIDsId = $$v
      },
      expression: "SRIDsId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("SR Name "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.SRNames,
      "placeholder": "Select SR Name",
      "selected-option": _vm.selectedSRNamenObj
    },
    on: {
      "select": _vm.selectedSRName
    },
    model: {
      value: (_vm.SRNameId),
      callback: function($$v) {
        _vm.SRNameId = $$v
      },
      expression: "SRNameId"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card c-email-app"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', [_c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("Preview:")]), _vm._v(" "), _c('div', [(_vm.userRole.toLowerCase() === 'associate') ? _c('p', [_c('EmailPreviewRaiseTicket', {
    attrs: {
      "setCaseID": [_vm.caseObj.caseid],
      "buttonType": 'eye'
    }
  }, [_vm._v("Preview ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("From:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(this.emailFrom))])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "to"
    }
  }, [_vm._v("To:")]), _vm._v(" "), (_vm.caseObj.email != null) ? _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caseObj.fromid),
      expression: "caseObj.fromid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "to_email",
      "id": "to_email",
      "placeholder": "Type email"
    },
    domProps: {
      "value": (_vm.caseObj.fromid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caseObj.fromid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('to_email')))])]) : _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caseObj.fromid),
      expression: "caseObj.fromid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "to_email",
      "id": "to_email",
      "placeholder": "Type email"
    },
    domProps: {
      "value": (_vm.caseObj.fromid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caseObj.fromid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('to_email')),
      expression: "errors.has('to_email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('to_email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row mb-3"
  }, [_c('label', {
    staticClass: "col-2 col-sm-1 col-form-label",
    attrs: {
      "for": "cc"
    }
  }, [_vm._v("CC:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11",
    attrs: {
      "cols": "12"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyTocc1),
      expression: "replyTocc1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "replyTocc1",
      "id": "replyTocc1",
      "placeholder": "Default - abc@xpressbees.com",
      "rows": "2",
      "cols": "125"
    },
    domProps: {
      "value": (_vm.replyTocc1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyTocc1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("To Add multiple Email ID give comma(,)")])])]), _vm._v(" "), (_vm.invalidEmailFlag) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("\n                                    Invalid Email Ids"), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.invalidEmail) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-1 col-sm-2 col-form-label",
    attrs: {
      "data-v-685aa076": "",
      "for": "message"
    }
  }, [_vm._v("Message:")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto col-sm-11"
  }, [_c('div', {
    staticClass: "form-group mt-4"
  }, [_c('wysiwyg', {
    attrs: {
      "id": "message",
      "name": "message"
    },
    model: {
      value: (_vm.reply),
      callback: function($$v) {
        _vm.reply = $$v
      },
      expression: "reply"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "mb-0 form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkEditShipmentAndSendMail()
      }
    }
  }, [_vm._v("Update")])])])])])], 1)], 1), _vm._v(" "), (_vm.ticketResultMsg != '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.ticket.length > 0 && _vm.ticketResultMsg != '') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    on: {
      "click": function($event) {
        _vm.listExisitngTicketModal = true;
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Update\n              Ticket")]) : _vm._e()])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54204631","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/emailtracking.vue
// module id = 907
// module chunks = 1